import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DescriptionAIDisclaimer = ({
  isUserEdited
}) => {
  const disclaimerMessage = isUserEdited ? 'summary.description.createdWithAIDisclaimer' : 'summary.description.aiDisclaimer';
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(BreezeSingleStarIcon, {
      size: "300",
      color: "do-not-use-obsidian"
    }), /*#__PURE__*/_jsx(Text, {
      as: "small",
      color: "text-core-subtle",
      marginInlineStart: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: disclaimerMessage
      })
    })]
  });
};
export default DescriptionAIDisclaimer;